<template>
  <div class="tideng-maze-page">
    <div v-wechat-title="'《提灯与地下城》提灯x迷宫惊喜联动'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :autoOpenOS='false' :gameName="gameName" :downloadUrl="downloadUrl"
      :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" v-on:loginSuccess="loginSuccess"></Login>

    <Os v-if='isShowOs' v-on:logoutCallback='osCancell' v-on:selectCallback='onBind()' :gameName="gameName"></Os>


    <!-- 头部 -->
    <header class="header-login">
      <div v-if="!user_info.role_name" class="acco">
        {{ user_info.account || '新版预约' }}
      </div>
      <div class="acco" v-else>{{ user_info.role_name }}[{{ user_info.server_name }}]</div>
      <a class="download-btn" title="下载按钮" @click="downloadApp"></a>
      <!-- 登录按钮：只有未登录时出现 -->
      <a v-if="!user_info.user_id" class="logon-btn" @click="logon()" title="登录&切换按钮"></a>

      <!-- 注销按钮-->
      <a v-else class="logout-btn" @click="qhBtn()"></a>
    </header>


    <div class="content-01">
      <div class="egg-one" :class="{ 'no-shake': eggShakeState[1] }" @click="getEggReward(1)"></div>
      <div class="slogan"></div>
    </div>

    <div class="content-02">
      <div class="welfare-box" :class="isRewardStart ? 'welfare-box-start' : 'welfare-box-before'">
        <div class="appoint-btn" :class="buttonClass" @click="appoint"></div>
      </div>
    </div>

    <!-- 轮播图 -->
    <div class="content-03">
      <div class="title_01"></div>
      <div class="game-feature-box">
        <div class="game-feature-content">
          <div class="game-feature-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in gameFeatureCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="game-feature-swiper-button-next swiper-button-next" @click="nextBtn"></div>
          <div class="game-feature-swiper-button-prev swiper-button-prev" @click="prevBtn"></div>
          <div class="game-feature-swiper-pagination swiper-pagination"></div>
        </div>
      </div>
    </div>


    <div class="content-04">
      <div class="title_02">
        <div class="rule-btn" @click="openRule"></div>
      </div>

      <div class="maze-content">
        <!-- 迷宫部分 -->
        <div class="maze">
          <div class="x-img"></div>

          <!-- 三个建筑 -->
          <div class="city-01" v-show="!isCityOpen(2)"></div>
          <div class="city-02" v-show="!isCityOpen(8)"></div>
          <div class="city-03" v-show="!isCityOpen(13)"></div>

          <div v-for="(cell, index) in maze_list" :key="cell.maze_id" class="cell" :class="[
            getTileClass(index + 1),
            { hide: cell.is_open },
            { glow: isGlow(cell.maze_id) }
          ]" @click="onClickCell(cell)">
          </div>
          <img v-for="cell in maze_list" v-if="currentSmokeId === cell.maze_id" :key="'smoke-' + cell.maze_id"
            :class="'smoke-global ' + `smoke-global-${cell.maze_id}`"
            src="https://download4.qcplay.com/qcgame-api/xjZjyxkqhiTBvINvOU5jI9brgACCTxuqiv8Pf101.png" />
          <!-- 第 10 格子不可见彩蛋 -->
          <div class="hidden-egg egg-2" v-if="eggVisible" @click="getEggReward(2)"></div>
        </div>

        <div class="activity-time"></div>
        <div class="reward-name"></div>
        <div class="role-talk"></div>
        <div class="explore-time">
          <span class="p-1">剩余探索次数</span>
          <span class="p-2">{{ time }}</span>
          <span class="p-3">次</span>
        </div>
        <div class="reward-btn" @click="showReWardList"></div>
      </div>
    </div>

    <div class="content-05">
      <div class="title_03"></div>

      <div class="task-container">
        <div class="task-list" v-if="taskInfo && taskInfo.length">
          <!-- 任务 1 -->
          <div v-if="taskInfo[0]" class="task task1">
            <div class="p1">{{ taskInfo[0].title }} ({{ taskInfo[0].is_get == 1 ? 1 : 0 }}/{{
              taskInfo[0].total_number }})</div>
            <div class="p2">探索次数 +1</div>
            <div class="task-btn" :class="getTaskBtnClass(taskInfo[0], 0)" @click="noLoginPop"></div>
          </div>

          <!-- 任务 2 -->
          <div v-if="taskInfo[1]" class="task task2">
            <div class="p1">{{ taskInfo[1].title }} ({{ taskInfo[1].is_get == 1 ? 1 : 0 }}/{{
              taskInfo[1].total_number }})</div>
            <div class="p2">探索次数 +1</div>
            <div class="task-btn" :class="getTaskBtnClass(taskInfo[1], 1)" @click="clickShare(taskInfo[1])"></div>
          </div>

          <!-- 任务 3 -->
          <div v-if="taskInfo[2]" class="task task3">
            <div class="p1">{{ taskInfo[2].title }}</div>
            <div class="p2">探索次数 +1</div>
            <div class="task-btn" :class="getTaskBtnClass(taskInfo[2], 2)" @click="noLoginPop"></div>
          </div>

          <!-- 任务 4 -->
          <div v-if="taskInfo[3]" class="task task4">
            <div class="p1">{{ taskInfo[3].title }}</div>
            <div class="p2">世界碎片+1,探索次数+1</div>
            <!-- 根据 count 值动态加类 -->
            <div class="task-btn" :class="'count' + taskInfo[3].count" @click="noLoginPop"></div>
          </div>
        </div>

        <div class="refresh-btn" @click="DebounceRefresh"></div>
      </div>
    </div>

    <div class="content-06">
      <div class="title_04"></div>
      <div class="activities-box">
        <div class="egg-three" :class="{ 'no-shake': eggShakeState[3] }" @click="getEggReward(3)"></div>
        <div class="activities-content">
          <div class="activities-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in activitiesCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="btn-go" @click="swiperLink"></div>
          <div class="new-game-feature-swiper-button-next swiper-button-next" @click="nextBtn1"></div>
          <div class="new-game-feature-swiper-button-prev swiper-button-prev" @click="prevBtn2"></div>
          <div class="new-game-feature-swiper-pagination swiper-pagination"></div>
        </div>
      </div>
    </div>


    <!-- 第一档的奖励弹窗 -->
    <div class="one_get_reward_wrap popup_wrap" v-show="oneRewardShow">
      <transition enter-active-class="popup-zoom-in" leave-active-class="popup-zoom-out">
        <div class="get_reward_box popup_wrap-box" v-show="oneRewardShow">
          <div class="light-circle"></div>
          <div :class="'reward-item reward-item-' + packageId"></div>
          <div class="reward-info">
            <div class="info">
              <span class="s-1">恭喜您探索到</span>
              <span class="s-2">{{ package_info }}</span>
            </div>
          </div>
          <div class="know-btn" @click="closePopup('oneRewardShow')"></div>
          <div class="close-btn" @click="closePopup('oneRewardShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="oneRewardShow" @click="closePopup('oneRewardShow')"></div>
    </div>
    <!-- 第二 -->
    <div class="two_get_reward_wrap popup_wrap" v-show="twoRewardShow">
      <transition enter-active-class="popup-zoom-in" leave-active-class="popup-zoom-out">
        <div class="get_reward_box popup_wrap-box" v-show="twoRewardShow">
          <div class="light-circle"></div>
          <div :class="'reward-item reward-item-' + packageId"></div>
          <div class="reward-info">
            <div class="info">
              <span class="s-1">恭喜您探索到</span>
              <span class="s-2">{{ package_info }}</span>
            </div>
          </div>

          <div class="know-btn" @click="closePopup('twoRewardShow')"></div>
          <div class="close-btn" @click="closePopup('twoRewardShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="twoRewardShow" @click="closePopup('twoRewardShow')"></div>
    </div>

    <!-- 第三 -->
    <div class="three_get_reward_wrap popup_wrap" v-show="threeRewardShow">
      <transition enter-active-class="popup-zoom-in" leave-active-class="popup-zoom-out">
        <div class="get_reward_box popup_wrap-box" v-show="threeRewardShow">
          <div class="light-circle"></div>
          <div :class="'reward-item reward-item-' + packageId"></div>
          <div class="reward-info">
            <div class="info">
              <span class="s-1">恭喜您探索到</span>
              <span class="s-2">{{ package_info }}</span>
            </div>
          </div>

          <div class="know-btn" @click="closePopup('threeRewardShow')"></div>
          <div class="close-btn" @click="closePopup('threeRewardShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="threeRewardShow" @click="closePopup('threeRewardShow')"></div>
    </div>

    <!-- 第四 -->
    <div class="four_get_reward_wrap popup_wrap" v-show="fourRewardShow">
      <transition enter-active-class="popup-zoom-in" leave-active-class="popup-zoom-out">
        <div class="get_reward_box popup_wrap-box" v-show="fourRewardShow">
          <div class="light-circle"></div>
          <div :class="'reward-item reward-item-' + packageId"></div>
          <div class="reward-info">
            <div class="info">
              <span class="s-1">恭喜您探索到</span>
              <span class="s-2">{{ package_info }}</span>
            </div>
          </div>

          <div class="know-btn" @click="closePopup('fourRewardShow')"></div>
          <div class="close-btn" @click="closePopup('fourRewardShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="fourRewardShow" @click="closePopup('fourRewardShow')"></div>
    </div>

    <!-- 第五 -->
    <div class="five_get_reward_wrap popup_wrap" v-show="fiveRewardShow">
      <transition enter-active-class="popup-zoom-in" leave-active-class="popup-zoom-out">
        <div class="get_reward_box popup_wrap-box" v-show="fiveRewardShow">
          <div class="light-circle"></div>
          <div :class="'reward-item reward-item-' + packageId"></div>
          <div class="reward-info">
            <div class="info">
              <span class="s-1">恭喜您探索到</span>
              <span class="s-2">{{ package_info }}</span>
            </div>
          </div>

          <div class="know-btn" @click="closePopup('fiveRewardShow')"></div>
          <div class="close-btn" @click="closePopup('fiveRewardShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="fiveRewardShow" @click="closePopup('fiveRewardShow')"></div>
    </div>

    <!-- 第六 -->
    <div class="six_get_reward_wrap popup_wrap" v-show="sixRewardShow">
      <transition enter-active-class="popup-zoom-in" leave-active-class="popup-zoom-out">
        <div class="get_reward_box popup_wrap-box" v-show="sixRewardShow">
          <div class="light-circle"></div>
          <div class="finish-title"></div>
          <div :class="'reward-item reward-item-779'"></div>
          <div class="reward-info">
            <div class="info">
              <span class="s-1">恭喜您探索到</span>
              <span class="s-2">钻石*666</span>
            </div>
          </div>

          <!-- <div class="light-round"></div> -->

          <div class="know-btn" @click="getAllFinal"></div>
          <div class="close-btn" @click="closePopup('sixRewardShow')" />
        </div>
      </transition>
      <!-- <div class="teshu"></div> -->
      <!-- <div class="big-light"></div> -->
      <div class="close-bg" v-show="sixRewardShow" @click="closePopup('sixRewardShow')"></div>
    </div>



    <!-- 点击方块探索弹窗 -->
    <div class="explore_fk_wrap popup_wrap" v-show="exploreFkShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="explore_fk_box popup_wrap-box" v-show="exploreFkShow">
          <div class="explore-left" @click="closePopup('exploreFkShow')"></div>
          <div class="explore-right" @click="explore"></div>
          <div class="close-btn" @click="closePopup('exploreFkShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="exploreFkShow" @click="closePopup('exploreFkShow')"></div>
    </div>


    <!-- 分享相关DOM -->
    <div class="share-box-tideng" ref="imageDom">
      <img src="https://download4.qcplay.com/qcgame-api/0WfPy618QNr2DyGZyt7IjITFduHVdN0TDpLwLVjY.png" />
      <div class="qrcode-box">
        <div id="qrcode" class="qrcode"></div>
      </div>
    </div>

    <!-- 分享助力弹窗 -->
    <div :class="'new-help-share-wrap popup_wrap new-help-share-wrap-' + shareShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="shareShow">
        <div class="new-help-share-box popup_wrap-box">
          <div class="bottom-img">
            <div class="qrcode-box">
              <div id="qrcode2" class="qrcode"></div>
            </div>
          </div>
          <img :src="shareImg" />
          <div class="new-clipboard-btn" @click="copyLink('.new-clipboard-btn', 1)" data-event="复制活动链接"
            :data-clipboard-text="`提灯x迷宫限时惊喜联动！
「限定头衔」超多钻石等你来领
地下城迷宫探险火热进行中
我离终极大奖就差一点了
「速戳」助我一臂之力！https://h5.qingcigame.com/tideng/maze/enter?help_id=${helpId}`">
          </div>
          <div class="tip-text"></div>
          <div class="new-close-btn" @click="closePopup('shareShow')"></div>
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('shareShow')"></div>
    </div>

    <!-- 助力成功 -->
    <div class="help_wrap popup_wrap" v-show="helpSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="help_success_box popup_wrap-box" v-show="helpSuccessShow">
          <div class="go-activity" @click="helpSuccessClick"></div>
          <div class="close-btn" @click="closePopup('helpSuccessShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="helpSuccessShow" @click="closePopup('helpSuccessShow')"></div>
    </div>

    <!-- 已助力过该玩家 -->
    <div class="helped_wrap popup_wrap" v-show="helpedShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="helped_wrap_box popup_wrap-box" v-show="helpedShow">
          <div class="go-activity" @click="helpedClick"></div>
          <div class="close-btn" @click="closePopup('helpedShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="helpedShow" @click="closePopup('helpedShow')"></div>
    </div>
    <!-- 助力失败 不能自己助力自己 -->
    <div class="new_help_self_wrap popup_wrap" v-show="helpSelfShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="new_help_self_box popup_wrap-box" v-show="helpSelfShow">
          <div class="copy-link" @click="copyLink('.copy-link', 2)" data-event="复制活动链接" :data-clipboard-text="`地下城迷宫困难重重
就差你的助力了！=͟͟͞͞( •̀д•́)
提灯与地下城x不思议迷宫惊喜联动！
超多钻石等你来领(✪ω✪)
我离终极大奖就差一点了
速戳助我一臂之力https://h5.qingcigame.com/tideng/maze/enter?help_id=${helpId}`"></div>
          <div class="close-btn" @click="closePopup('helpSelfShow')" />
        </div>
      </transition>
      <div class="close-bg" v-show="helpSelfShow" @click="closePopup('helpSelfShow')"></div>
    </div>


    <!-- 角色选择弹窗 -->
    <div class="tideng-role-select-wrap popup_wrap" v-show="tidengRoleSelect">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="tideng-role-select-box popup_wrap-box" v-show="tidengRoleSelect">

          <div class="option-box">
            <div class="input">
              <select class="fl" v-model="productOs" @focus="inputFocus()" @focusout="inputFocusOut"
                @change="selectedRoleID = ''">
                <option value="">请选择设备</option>
                <option value="ios">Ios</option>
                <option value="android">Android
                </option>
              </select>
              <select v-model="selectedRoleID" @focus="inputFocus()" @focusout="inputFocusOut()">
                <option value="">请选择区组</option>
                <option v-for="(item, index) in roleListByOs" :key="index" :value="item.role_id">
                  <span>{{ "区服:" + item.server_name }}</span>
                </option>
              </select>
            </div>
            <div class="input input-name">
              <input type="text" name="" readonly v-model="roleName" placeholder="请选择角色(用于领取奖励)" @focus="inputFocus()"
                @focusout="inputFocusOut()" />
            </div>
          </div>
          <div class="logout-btn" @click="roleLogOut"></div>
          <div class="confirm-btn" @click="reConfirmBindRolePopup()"></div>
          <div class="close-btn" @click="closePopup('tidengRoleSelect')" />
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('tidengRoleSelect')"></div>
    </div>

    <!-- 注销弹窗 -->
    <div class="logout-wrap popup_wrap" v-show="logoutShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="logout-box popup_wrap-box" v-show="logoutShow">
          <p>是否退出当前账号</p>
          <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
          <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
        </div>
      </transition>
    </div>

    <!-- 绑定角色二次确认弹窗 -->
    <div class="tideng-bind-role-confirm-wrap popup_wrap" v-show="bindRoleConfirmShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="tideng-bind-role-confirm-box popup_wrap-box" v-show="bindRoleConfirmShow">
          <div class="tips">
            <span>[{{ selectedRoleInfo.server_name }}]</span>
            <span class="name">{{ selectedRoleInfo.role_name }}</span>
          </div>

          <div class="btn left-btn" @click="closeReConfirmBindRole()"></div>
          <div class="btn right-btn" @click="debouncedConfirmBindRole()"></div>
          <div class="close-btn" @click="closePopup('bindRoleConfirmShow')" />
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('bindRoleConfirmShow')"></div>
    </div>

    <!-- 活动期间领取奖励成功弹窗 -->
    <div class="reward-success-pop popup_wrap" v-show="getRewardSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="reward-success-box popup_wrap-box" v-show="getRewardSuccessShow">
          <div class="confirm-btn" @click="closePopup('getRewardSuccessShow')"></div>
          <div class="close-btn" @click="closePopup('getRewardSuccessShow')" />
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('getRewardSuccessShow')"></div>
    </div>

    <!-- 预约成功弹窗 -->
    <div class="appoint-success-pop popup_wrap" v-show="appointSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="success-box popup_wrap-box" v-show="appointSuccessShow">
          <div class="confirm-btn" @click="closePopup('appointSuccessShow')"></div>
          <div class="close-btn" @click="closePopup('appointSuccessShow')" />
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('appointSuccessShow')"></div>
    </div>

    <!-- 活动说明弹窗 -->
    <div class="rule-detail-wrap popup_wrap" v-show="ruleShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="rule-detail-box popup_wrap-box" v-show="ruleShow">
          <div class="confirm-btn" @click="closePopup('ruleShow')"></div>
          <div class="close-btn" @click="closePopup('ruleShow')" />
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('ruleShow')"></div>
    </div>

    <!-- 没有奖品弹窗 -->
    <div class="no-reward-wrap popup_wrap" v-show="noReWardShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="no-reward-box popup_wrap-box" v-show="noReWardShow">
          <div class="confirm-btn" @click="closePopup('noReWardShow')"></div>
          <div class="close-btn" @click="closePopup('noReWardShow')"></div>
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('noReWardShow')"></div>
    </div>

    <!-- 奖励信息弹窗 -->
    <div class="reward-list-wrap popup_wrap" v-show="rewardListShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="reward-list-box popup_wrap-box" v-show="rewardListShow">
          <div class="list">
            <ul>
              <li v-for="(item, index) in record_list" :key="index"><span>{{ item.updated_at }}</span><span>{{
                item.remark
              }}</span></li>
            </ul>
          </div>
          <div class="close-btn" @click="closePopup('rewardListShow')"></div>
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('rewardListShow')"></div>
    </div>

    <!-- 彩蛋弹窗 -->
    <div :class="'egg-reward-wrap popup_wrap egg-reward-wrap-' + eggShow" v-show="eggShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div :class="'egg-reward-box popup_wrap-box egg-' + egg_id" v-show="eggShow">
          <a class="confirm-btn" href="javascript:;" @click="eggClick"></a>
          <div class="close-btn" @click="closePopup('eggShow')"></div>
        </div>
      </transition>
      <div class="close-bg" @click="closePopup('eggShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

    <!-- 微信下载 -->
    <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { GetRoleList } from "@/api/os";
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from '@/components/Footer';
import Os from '@/components/os';
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import {
  onGetInitDataAPI, appointAPI, bindRoleAndGetAwardAPI, getEggRewardAPI, onHelpAPI, clickFkAPI, LogoutAPI, downloadApps
} from '../api';
import { getTimeStamp, analysisParams, buriedLogger, getRandomString, wechatBrowser } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'maze',
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    const rewardStartTime = new Date("2025-12-25 11:00:00").getTime();
    const now = Date.now();
    return {
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-hykb-950564.apk',
        ios_url: 'https://apps.apple.com/cn/app/%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E/id1507356201?l=en-GB',
      },
      resetKeys: [
        'oneRewardShow',
        'twoRewardShow',
        'threeRewardShow',
        'fourRewardShow',
        'fiveRewardShow',
        'sixRewardShow',
        'exploreFkShow',
        'shareShow',
        'helpSuccessShow',
        'helpedShow',
        'helpSelfShow',
        'bindRoleConfirmShow',
        'tidengRoleSelect',
        'getRewardSuccessShow',
        'appointSuccessShow',
        'eggShow',
        'ruleShow',
        'noReWardShow',
        'rewardListShow',
        'preventShow'
      ],
      // 初始化时，根据本地缓存决定是否抖动
      eggShakeState: {
        1: true,
        2: true,
        3: true
      }, // 先声明为空对象
      eggVisible: false,
      wxLoadShow: false,

      toastLock: false,
      isFinalReward: 0, // 当前是否最后一次探索// 探索完成
      helpId: '', // 邀请id 
      logoutShow: false, // 注销弹窗
      packageId: "",
      activity_start: false, // 默认活动没开始

      logger: null,
      eggCount: '', // 第二个彩蛋计数

      is_bind: 0, // 是否绑定了账号
      isRefreshing: false, // 防抖锁
      // 迷宫部分
      maze_list: Array.from({ length: 16 }, (_, i) => ({
        maze_id: i + 1,
        is_open: false,   // 初始都未打开
        // 这里可以加上任何你cg格子本来该有的字段
      })),
      now_walk_number: 0, // 这个是用户当前在的位置
      can_walk_number: [], // 这个是当前可以点亮的格子
      currentSmokeId: null, // 当前播放烟雾的方块 ID
      nowClickFk: '',

      user_info: {}, // 用户信息
      gameName: 'tideng',
      downloadUrl: 'https://tideng.qingcigame.com/official/index_mobile.html',
      loginTypes: ["sms", "password"],
      time: 0, // 剩余探索次数
      // 预约相关的变量
      isBook: false, //  是否预约
      // isRewardStart: false, // 是否可以领取预约奖励
      isRewardStart: now >= rewardStartTime,
      isBookSend: false, // 是否领取预约奖励
      taskInfo: [
        {
          title: "每日完成1次游戏登录",
          _get: false,
          is_get: false,
          count: 0,
          total_number: 1
        }, {
          title: "每日完成好友助力1次",
          _get: false,
          is_get: false,
          count: 0,
          total_number: 1
        }, {
          title: "每日消耗100精力",
          _get: false
        }, {
          title: "收集活动页中掉落的世界碎片",
          _get: false,
          count: 0,
          total_number: 3
        }
      ], // 任务列表
      record_list: [
      ], // 奖励信息
      gameFeatureCards: [
        { id: 1, image: 'https://download4.qcplay.com/qcgame-api/PYSfiZocwUcEk4JvwWeTilVWPLmJTiQysteFs8BF.png' },
        { id: 2, image: 'https://download4.qcplay.com/qcgame-api/MWL0iNNnYWtIXqoYdp6ktuJqn6bMnlxmBOPP1OLu.png' },
        { id: 3, image: 'https://download4.qcplay.com/qcgame-api/fPr5s2qE1zjKvFxfocj3lywcA2GSMfkhaiMfaAye.png' },
      ], // 轮播图数组
      timer: null,
      activeIndex: 0,
      // 更多咨询轮播图
      activitiesCards: [
        { id: 1, image: 'https://download4.qcplay.com/qcgame-api/uV7XwtItNGH7Mpln8qAIRtzva93iPRSgfT9vGs1u.png', url: 'https://pay.qingcigame.com/pay?gameId=33' },
        { id: 2, image: 'https://download4.qcplay.com/qcgame-api/QgV9upgJSXNPj4WlBwZ6yaQiGGfIYndzxCB2n4GX.png', url: 'https://l.taptap.cn/zOvDMJaD?channel=rep-rep_gxbhkhykyqm' },
        { id: 3, image: 'https://download4.qcplay.com/qcgame-api/ZwNjO6CTCjONfp5XxcUKZbDA97X4POxiC2ljJggF.png', url: 'https://www.taptap.cn/events/game-sign/szkvhnmb' },
      ],

      shareImg: '', // 生成分享图片相关变量

      // 绑定角色相关变量
      productOs: "", // 设备 ios 或者 android
      roleList: [],
      selectedRoleID: "",
      selectedRoleInfo: {}, // 当前绑定选中的角色信息

      activitiesSwiper: null,
      gameFeatureSwiper: null, // 轮播图对象

      egg_id: 1,  // 彩蛋id 序号

      // 弹窗
      package_info: '', // 当前的奖励名称
      oneRewardShow: false, // 奖励1弹窗
      twoRewardShow: false, // 2
      threeRewardShow: false, // 3
      fourRewardShow: false, // 4
      fiveRewardShow: false, // 5
      sixRewardShow: false, // 6




      exploreFkShow: false, // 点击方块探索弹出的弹窗
      shareShow: false, // 分享助力弹窗
      helpSuccessShow: false, // 助力成功弹窗
      helpedShow: false, // 今日已助力过弹窗
      helpSelfShow: false, // 助力自己弹窗
      bindRoleConfirmShow: false, // 绑定角色二次确认弹窗
      tidengRoleSelect: false, // 角色选择弹窗
      getRewardSuccessShow: false, // 活动期间领取奖励成功弹窗
      appointSuccessShow: false, // 预约成功弹窗
      eggShow: false, //  彩蛋弹窗
      ruleShow: false,  // 活动说明弹窗
      noReWardShow: false, // 没有奖品时的弹窗
      rewardListShow: false, // 有奖品时的弹窗
      preventShow: false, // 全局遮罩
    }
  },
  created() {
    const bl = buriedLogger('tideng', '提灯x迷宫联动版本');
    this.logger = bl

    const params = analysisParams(window.location.href);
    const { download_id } = params;
    download_id && downloadApps({ download_id, title: 'title' }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    });

    this.initializeDebounceMethods();
  },
  mounted() {
    this.initSwiper();
    this.initSwiperGameFeature();
    if (!this.userInfo.account) {
      this.getLoginContainer()
    }
    this.$nextTick(() => {
      var linkUrl = `https://h5.qingcigame.com/tideng/maze/enter${getRandomString()}`;
      this.isSetShare(linkUrl);
    })
    this.monitoringEquipment();

    const params = analysisParams(window.location.href);
    const { help_id } = params;

    if (help_id) {
      onHelpAPI({ help_id }).then((res) => {
        if (res.code === 200) {
          // 200是成功
          this.showPopup('helpSuccessShow')
        } else if (res.code === 405) {
          // 405 很抱歉,该好友今日助力已完成
          this.showPopup('helpedShow')
        } else if (res.code === 406) {
          //406 是助力自己
          this.showPopup('helpSelfShow')
        } else {
          this.onToast(res.message)
        }
      })
    }

    const newIcon = 'https://download4.qcplay.com/qcgame-api/6XUeNsaV7EmJspyW5tFADyZj8P8kluVU5AOZZRrO.png'

    // 找到 <link rel="icon">
    let link = document.querySelector("link[rel~='icon']")

    // 如果找不到，则新建一个
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }

    // 替换路径
    link.href = newIcon
  },
  computed: {
    buttonClass() {
      // ---------- 预约期 ----------
      if (!this.isRewardStart) {
        return this.isBook ? 'btn-appointed' : 'btn-book'
      }
      // ---------- 活动期 ----------
      if (!this.isBookSend) {
        return 'btn-receive'  // 可领未领
      }
      return 'btn-received'   // 已领取
    },
    // 当前平台下的区服列表
    roleListByOs() {
      if (!this.productOs) return [];
      return this.roleList[this.productOs] || [];
    },
    // 根据选中区组ID显示角色名
    roleName() {
      if (!this.selectedRoleID || !this.productOs) return '';
      const list = this.roleList[this.productOs] || [];
      const role = list.find(item => item.role_id === this.selectedRoleID);
      return role ? role.role_name : '';
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              this.reInit();
            } else {
              this.getLoginContainer()
            }
          }
        }
      }
    },
  },
  methods: {
    downloadApp() {
      const isWechat = wechatBrowser()
      if (isWechat) {
        this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls;
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    stopEggShake(number) {
      this.$set(this.eggShakeState, number, false);
    },
    // 读取本地缓存，初始化抖动状态
    initEggShakeState() {
      const result = {};
      const account = this.user_info.account || '';

      // 第一段：初始化
      if (!this.activity_start) {
        // 活动没开始 → 全部 true
        for (let i = 1; i <= 5; i++) {
          // 还没开始不抖动
          result[i] = true;
        }
      } else {
        // 活动开始 → 全部 false 即抖动
        for (let i = 1; i <= 5; i++) {
          result[i] = false;
        }
      }

      // 第二段：缓存覆盖（活动开始时有本地缓存）
      if (this.activity_start) {
        for (let i = 1; i <= 5; i++) {
          const key = `${account}_egg_${i}`;
          // true = 要抖动（即本地未领取）
          result[i] = localStorage.getItem(key);
        }
      }

      // 第三段：返回最终结果
      return result;
    },

    initEggVisible() {
      const account = this.user_info.account || '';
      const key = `${account}_egg_2`;

      return !localStorage.getItem(key);
    },

    roleLogOut() {
      this.closePopup('tidengRoleSelect')
      this.logoutShow = true
    },
    loginSuccess() {
      this.getLoginContainer()

      const params = analysisParams(window.location.href);
      const { help_id } = params;

      if (help_id) {
        onHelpAPI({ help_id }).then((res) => {
          if (res.code === 200) {
            // 200是成功
            this.showPopup('helpSuccessShow')
          } else if (res.code === 405) {
            // 405 很抱歉,该好友今日助力已完成
            this.showPopup('helpedShow')
          } else if (res.code === 406) {
            //406 是助力自己
            this.showPopup('helpSelfShow')
          } else {
            this.onToast(res.message)
          }
        })
      }
    },
    logoutBtn() {
      LogoutAPI().then((response) => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.reInit()
          // this.osCancell()
          this.user_info = {}
          this.logoutShow = false
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
        }
      });
    },
    qhBtn() {
      this.logoutShow = true
    },
    eggClick() {
      this.closePopup('eggShow')
      if (this.egg_id == 2) {
        this.logger.sum("提灯x迷宫联动版本_点击彩蛋2弹窗“我已知晓”按钮的次数");
      }
    },
    helpSuccessClick() {
      this.closePopup('helpSuccessShow')
      this.logger.sum("提灯x迷宫联动版本_点击助力成功查看活动按钮的人数和次数");
    },
    helpedClick() {
      this.closePopup('helpedShow')
      this.logger.sum("提灯x迷宫联动版本_点击助力失败（已助力）查看活动按钮的人数和次数");
    },
    getAllFinal() {
      this.closePopup('sixRewardShow')
      this.logger.sum("提灯x迷宫联动版本_点击探索完成弹窗“我已知晓”按钮的人数和次数");
    },
    nextBtn() {
      this.logger.sum("提灯x迷宫联动版本_点击联动情报左箭头的次数和人数");
    },
    prevBtn() {
      this.logger.sum("提灯x迷宫联动版本_点击联动情报右箭头的次数和人数");
    },
    nextBtn1() {
      this.logger.sum("提灯x迷宫联动版本_点击资讯左箭头的次数和人数");
    },
    prevBtn2() {
      this.logger.sum("提灯x迷宫联动版本_点击资讯右箭头的次数和人数");
    },
    monitoringEquipment() {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/tideng/maze/pc${getTimeStamp()}`
    },
    initializeDebounceMethods() {
      const accessToken = window.localStorage.getItem("access_token");
      const delay1 = accessToken ? 1100 : 0;

      // 角色列表防抖
      this.onBindRolePopup = _.debounce(
        this.onBindRolePopup,
        800,
        {
          leading: true,
          trailing: false
        }
      );

      // 领取奖励
      this.debouncedRequestAward = _.debounce(this.requestReceiveAward, delay1, {
        leading: true,
        trailing: false
      })

      this.DebounceRefresh = _.debounce(this._refresh, delay1, {
        leading: true,
        trailing: false
      });

      this.debouncedConfirmBindRole = _.debounce(this.requestConfirmBindRole, delay1, {
        leading: true,
        trailing: false,
      })

      this.debouncedRequestAppoint = _.debounce(this.requestAppointAward, delay1, {
        leading: true,
        trailing: false,
      })

      // 探索
      this.debouncedRequestExplore = _.debounce(this.requestExplore, delay1, {
        leading: true,
        trailing: false,
      })
      this.debouncedRequestEggReward = _.debounce(this.requestEggReward, delay1, {
        leading: true,
        trailing: false,
      });
    },
    noLoginPop() {
      if (!this.checkLogin()) {
        return;
      }
    },
    /** 判断城市对应格子是否已经打开 */
    isCityOpen(id) {
      // 找对应的格子
      const found = this.maze_list.find(cell => cell.maze_id === id)
      // 找到并且 is_open 为 true 时，返回 true
      return found ? found.is_open === true : false
    },
    swiperLink() {
      this.logger.sum("提灯x迷宫联动版本_点击前往活动按钮的人数和次数");
      const card = this.activitiesCards[this.activeIndex];

      // 只在 activeIndex 为 1 或 2 时做时间校验
      if (this.activeIndex == 1 || this.activeIndex == 2) {
        if (!this.isRewardStart) {
          console.log('231')
          this.onToast("活动暂未开始");
          return;
        }
      }

      if (card) window.open(card.url);
    },
    // 探索逻辑
    explore() {
      if (this.preventShow) return; // 防止动画未完成又点击
      this.closePopup("exploreFkShow")
      this.preventShow = true
      // 1. 标记当前烟雾的格子 id
      this.currentSmokeId = this.nowClickFk.maze_id

      const smokeDuration = 750;

      // 2. 并发执行动画 + 请求接口
      const apiPromise = new Promise((resolve) => {
        // 使用防抖版 API 请求（leading:true, trailing:false）
        this.debouncedRequestExplore(resolve);
      });
      const smokePromise = new Promise((resolve) =>
        setTimeout(resolve, smokeDuration)
      );

      Promise.all([apiPromise, smokePromise]).then(([response]) => {
        this.currentSmokeId = null;
        this.preventShow = false;

        if (!response || Number(response.code) !== 200) {
          this.onToast(response.message);
          return;
        }

        this.package_info = response.data.package_info;
        this.packageId = response.data.package_id
        this.getLoginContainer();

        const data = response.data;

        // 标记当前探索是否为最后一次
        this.isFinalReward = data.is_finish == 1;

        this.showRewardPopup(data.prop_id);
      });
    },
    // 请求逻辑
    requestExplore(resolve) {
      clickFkAPI({ number: this.nowClickFk.maze_id })
        .then((response) => resolve(response))
        .catch((err) => resolve({ message: err.message }));
    },
    showFinalReward() {
      // 清空所有弹窗状态
      this.closeAllRewardPopups();
      // 弹出最终大奖
      this.sixRewardShow = true;
    },
    closeAllRewardPopups() {
      this.oneRewardShow = false;
      this.twoRewardShow = false;
      this.threeRewardShow = false;
      this.fourRewardShow = false;
      this.fiveRewardShow = false;
      this.sixRewardShow = false;
    },
    // 根据 prop_id 映射显示弹窗
    showRewardPopup(prop_id) {
      // 清空之前的弹窗状态
      this.oneRewardShow = this.twoRewardShow = this.threeRewardShow = this.fourRewardShow = this.fiveRewardShow = false;

      // 根据 rewardType 打开对应弹窗
      switch (prop_id) {
        case 1:
          this.oneRewardShow = true; // 黄色
          break;
        case 2:
          this.twoRewardShow = true; // 绿色
          break;
        case 3:
          this.threeRewardShow = true; // 蓝色
          break;
        case 4:
          this.fourRewardShow = true; // 紫色
          break;
        case 5:
          this.fiveRewardShow = true; // 橙红色
          break;
        default:
          this.onToast("未知的奖励类型");
      }
    },
    /** 砖块对应的基础 class (确定编号 1~16) */
    getTileClass(index) {
      return `tile-${index}`
    },
    /** 是否发光 */
    isGlow(id) {
      return Array.isArray(this.can_walk_number) && this.can_walk_number.map(String).includes(String(id))
    },
    onClickCell(cell) {
      if (!this.checkLogin()) {
        return;
      }

      // 活动未开始
      if (!this.activity_start) {
        this.onToast('活动暂未开始，12月25日再来吧')
        return
      }

      // 还没绑定
      if (this.is_bind == 0) {
        this.onToast("很抱歉,请先绑定角色再探索!")
        this.onBindRolePopup();
        return
      }
      if (this.time == 0) {
        this.onToast("很抱歉,您的探索次数不足了!")
        return
      }

      // 判断探索的权限
      const id = String(cell.maze_id);
      const canWalk = Array.isArray(this.can_walk_number) && this.can_walk_number.map(String).includes(id);

      if (!canWalk) {
        this.onToast("这块迷宫还没有解锁噢，试试其他的吧~");
        return;
      }

      // 点击方块需要什么
      this.showPopup('exploreFkShow')
      this.nowClickFk = cell
      this.logger.sum(`提灯x迷宫联动版本_点击第${cell.maze_id}个迷宫块的人数`);
    },
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '地下城迷宫探险火热进行中！',
        imgUrl:
          'https://download4.qcplay.com/qcgame-api/uuPXazUmYUYjC54Onap3JajOVTG5di8tFIWuh7Ro.png',
        desc: '提灯x迷宫惊喜联动，「限定头衔」等你来领！终极大奖近在咫尺，「速戳」助我一臂之力',
      })
    },
    // 点击任务2的分享
    clickShare() {
      if (!this.checkLogin()) {
        return;
      }
      // 活动未开始
      if (!this.activity_start) {
        return
      }
      this.logger.sum(`提灯x迷宫联动版本_点击立即分享按钮的人数和次数`);
      setTimeout(() => {
        let qrUrl = `https://h5.qingcigame.com/tideng/maze/enter?help_id=${this.helpId}`
        this.qrcode('qrcode', qrUrl);
        this.qrcode('qrcode2', qrUrl);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      }, 500)
    },
    // 复制链接
    copyLink(copyName, type) {
      if (type == 1) {
        // 分享助力弹窗
        this.logger.sum(`提灯x迷宫联动版本_分享弹窗点击复制链接按钮的人数和次数`);
      } else {
        // 不能助力自己
        this.logger.sum(`提灯x迷宫联动版本_助力失败（分享给自己）点击复制链接按钮的人数和次数`);
      }
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on('success', (e) => {
        _this.onToast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        _this.onToast('复制失败')
      })
    },
    //  图片分享相关
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#9097b8',  // 二维码方块颜色（蓝灰）
        colorLight: '#1d2450'  // 背景颜色（深蓝紫）
      });
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          Indicator.close();
          console.log(canvas, 'canvas')
          this.preventShow = false;
          this.shareShow = true
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          Indicator.close();
          this.preventShow = false
          console.log('err: 图片生成失败', err.message);
        });
    },
    //  刷新按钮
    _refresh() {
      if (!this.checkLogin()) {
        return;
      }

      // 活动未开始
      if (!this.activity_start) {
        this.onToast('活动暂未开始，12月25日再来吧')
        return
      }

      this.logger.sum("提灯x迷宫联动版本_点击刷新状态按钮的人数和次数");
      this.getLoginContainer()
      this.onToast('刷新成功')
    },
    // 任务按钮状态
    getTaskBtnClass(item, index) {
      if (item._get) return 'btn-finished'; // 已完成图
      if (index == 1) return 'btn-share';  // 第二个任务：立即分享图
      return 'btn-unfinished';              // 默认：未完成图
    },
    // 预约/领奖
    appoint() {
      if (!this.checkLogin()) return

      // ① 未预约 → 立即预约
      if (!this.isBook && !this.isRewardStart) {
        this.logger.sum("提灯x迷宫联动版本_点击立即预约的人数");
        // this.appointAward();
        this.debouncedRequestAppoint()
        return;
      }

      // ② 已预约，时间未到 → 提示“到时间再来领取奖励”
      if (this.isBook && !this.isRewardStart) {
        this.logger.sum("提灯x迷宫联动版本_预约成功后重复点击已预约按钮的人数和次数");
        this.onToast('预约成功！请于12月25日在当前页面领取奖励');
        return;
      }

      // isBookSend 代表的是否领取预约奖励
      // ③ 时间到了，未领奖 → 弹出领奖弹窗（如弹角色绑定）
      if (this.isRewardStart && !this.isBookSend) {
        if (!this.userInfo.rid) {
          // 未绑定角色 - 弹绑定弹窗
          // this.onBindRolePopup();
          this.onBindRolePopup()
        } else {
          this.logger.sum("提灯x迷宫联动版本_正式活动期时点击立即领取按钮的人数");
          this.debouncedRequestAward(); //领奖
        }
        return;
      }

      // ④ 已预约、已领奖 → 提示“你已领奖”
      if (this.isRewardStart && this.isBookSend) {
        this.downloadApp()
        this.logger.sum("提灯x迷宫联动版本_正式活动期点击下载游戏按钮的人数");

        // 领奖这边要做下载游戏的跳转
        return;
      }
    },

    // 角色选弹窗
    async onBindRolePopup() {
      if (!this.checkLogin()) return


      // 获取角色信息 打开角色选择弹窗
      const roleResponse = await GetRoleList({
        account: this.userInfo.account,
        page_id: PAGE_ID[this.gameName],
        app_id: APP_ID[this.gameName]
      });

      if (Number(roleResponse.code) === 200) {
        // 获取所有区服数据
        const roleData = roleResponse.data;

        // 获取正式服和先锋服 ID（tideng 固定两个区服）
        const officialId = GAME_AREA[this.gameName][1].id; // 正式服 33
        const pioneerId = GAME_AREA[this.gameName][0].id;  // 先锋服 42

        // 取出对应的区服数据（防止 undefined，默认为 {}）
        const officialData = roleData[officialId] || {};
        const pioneerData = roleData[pioneerId] || {};

        // 按平台合并（安卓 + iOS）
        const mergedData = {
          android: (officialData.android || []).concat(pioneerData.android || []),
          ios: (officialData.ios || []).concat(pioneerData.ios || [])
        }

        this.roleList = mergedData;
        this.selectedRoleID = "";
        this.selectedRoleInfo = {};
        this.showPopup("tidengRoleSelect");
      }
    },

    // 角色信息二次确认的按钮方法
    reConfirmBindRolePopup() {
      if (this.productOs === "") {
        return this.onToast('请选择设备');
      }
      if (this.selectedRoleID === "") {
        return this.onToast('请选择区组');
      }
      let selectInfo = this.roleList[this.productOs].find(
        item => item.role_id === this.selectedRoleID
      );
      // selectInfo.type = "android";

      selectInfo.type = this.productOs // 这里可能有ios
      selectInfo.dist = APP_ID[this.gameName];
      selectInfo.extra = JSON.stringify(selectInfo.extra);
      this.selectedRoleInfo = selectInfo;
      this.closePopup("tidengRoleSelect");
      this.showPopup('bindRoleConfirmShow');

    },
    closeReConfirmBindRole() {
      this.selectedRoleInfo = {};
      this.showPopup("tidengRoleSelect")
      this.closePopup('bindRoleConfirmShow');
    },
    requestConfirmBindRole() {
      bindRoleAndGetAwardAPI({
        ...this.selectedRoleInfo,
        is_bind: 1,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.closePopup("bindRoleConfirmShow");
          this.onToast('绑定成功');
          this.getLoginContainer()
        } else {
          this.onToast(response.message);
        }
      }).finally(() => {
        this.onPreventClose();
      });
    },

    requestReceiveAward() {
      if (!this.selectedRoleInfo || Object.keys(this.selectedRoleInfo).length === 0) {
        this.selectedRoleInfo = { ...this.user_info } // 用浅拷贝保证响应式
      }
      bindRoleAndGetAwardAPI({
        ...this.selectedRoleInfo,
        is_bind: 0
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.getLoginContainer();
          this.showPopup("getRewardSuccessShow")
        } else {
          this.onToast(response.message);
        }
      })
    },

    requestAppointAward() {
      appointAPI().then((response) => {
        if (response.code == 200) {
          this.logger.sum("提灯x迷宫联动版本_统计预约成功的人数");
          this.appointSuccessShow = true;
          this.isBook = true;
          this.onToast("恭喜您，预约成功！12月25日活动开始后在当前页面领取奖励噢~")
          this.getLoginContainer();
        } else {
          this.onToast(response.message);
        }
      })
    },

    openRule() {
      this.logger.sum("提灯x迷宫联动版本_点击规则按钮的次数和人数");
      this.showPopup('ruleShow')
    },
    // 底部资讯轮播图
    initSwiper() {
      this.activitiesSwiper = new Swiper('.activities-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.new-game-feature-swiper-pagination',
        paginationClickable: true,
        nextButton: '.new-game-feature-swiper-button-next',
        prevButton: '.new-game-feature-swiper-button-prev',
        onSlideChangeStart: (swiper) => {
          this.activeIndex = swiper.realIndex
        }
      })
    },
    // 中部轮播图初始化
    initSwiperGameFeature() {
      this.gameFeatureSwiper = new Swiper('.game-feature-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.game-feature-swiper-pagination',
        paginationClickable: true,
        nextButton: '.game-feature-swiper-button-next',
        prevButton: '.game-feature-swiper-button-prev',
      })
    },

    // 领取彩蛋奖励
    getEggReward(number) {
      if (!this.checkLogin()) return;

      // 活动未开始
      if (!this.activity_start) {
        return
      }

      const account = this.user_info.account || '';

      const key = `${account}_egg_${number}`;
      // true = 要抖动（即本地未领取）
      let now_get = localStorage.getItem(key);
      if (now_get == 1) {
        this.onToast("该碎片已找到，找找其他的吧~")
        return
      }
      if (number == 2) {
        if (this.toastLock) return; // 防止连续增长 eggCount

        this.eggCount = (this.eggCount || 0) + 1;

        if (this.eggCount == 2) {
          return this.showEggToast('有点松动');
        }

        if (this.eggCount == 3) {
          return this.showEggToast('下面似乎有谁抠着');
        }

        if (this.eggCount >= 5) {
          return this.debouncedRequestEggReward(number);
        }

        return;
      }

      this.debouncedRequestEggReward(number);
    },

    // 发请求逻辑（纯网络操作）
    requestEggReward(number) {
      getEggRewardAPI({ number }).then((response) => {
        if (Number(response.code) === 200) {
          this.logger.sum(`提灯x迷宫联动版本_点击彩蛋${number}的人数`);
          this.egg_id = number;

          // 写入缓存
          const key = `${this.user_info.account}_egg_${number}`;
          localStorage.setItem(key, "1");

          // 领到彩蛋 1、3 → 只停止抖动
          if (number === 1 || number === 3) {
            // 停止抖动
            this.stopEggShake(number);
          }

          // 彩蛋 2 → 隐藏
          if (number === 2) {
            this.eggVisible = false;
          }

          this.showPopup('eggShow');
          this.getLoginContainer();
        } else if (response.code === 406) {
          this.onToast("该碎片已找到，找找其他的吧~")
        } else {
          this.onToast(response.message);
        }
      });
    },

    // 点击我的奖品按钮
    showReWardList() {
      this.logger.sum("提灯x迷宫联动版本_点击我的奖品按钮的次数和人数");
      if (!this.checkLogin()) return

      // 活动未开始
      if (!this.activity_start) {
        this.onToast('活动暂未开始，12月25日再来吧')
        return
      }

      if (this.record_list.length == 0) {
        this.noReWardShow = true
      } else {
        this.rewardListShow = true
      }
    },

    // 如果未登录 点击按钮的逻辑
    checkLogin() {
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return false
      }
      return true
    },

    logon() {
      this.changeLoginPopup(true);
    },
    switchBtn() {
      this.changeOsPopup(true)
    },
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.activity = response.data.activity;
            this.user_info = response.data.user_info;

            this.helpId = this.user_info.user_id;

            this.time = this.activity.times // 剩余探索次数
            this.record_list = this.activity.record_list // 奖品列表 先注释掉调试有奖品时的
            this.taskInfo = this.activity.task_info // 任务列表

            this.is_bind = response.data.activity.is_bind // 是否绑定了账号
            this.isBook = response.data.activity.is_book; // 是否预约
            this.isRewardStart = response.data.activity.is_reward_start; // 是否可以领取预约奖励
            this.isBookSend = response.data.activity.is_send; // 是否领取预约奖励

            this.activity_start = response.data.activity.activity_start // 活动是否开始

            this.maze_list = response.data.activity.maze_list
            this.can_walk_number = response.data.activity.can_walk_number // 这个是当前可以点亮的格子
            const params = analysisParams(window.location.href);

            // 在实例已创建时才能安全使用 this
            this.eggShakeState = this.initEggShakeState();
            this.eggVisible = this.initEggVisible()
            this.onInitDataCallback(response);

            this.setUserInfo(response.data.user_info);
            this.setActiveInfo(response.data.activity);
            return;
          }
        })
    },

    onBind() {
      this.getLoginContainer();
      this.initializeDebounceMethods();
    },

    reInit() {
      this.changeOsPopup(false);
      this.clearActiveInfo();
      this.taskInfo = [
        {
          title: "每日完成1次游戏登录",
          _get: false,
          count: 0,
          is_get: false,
          total_number: 1
        }, {
          title: "每日完成好友助力1次",
          _get: false,
          count: 0,
          is_get: false,
          total_number: 1
        }, {
          title: "每日消耗100精力",
          _get: false
        }, {
          title: "收集活动页中掉落的世界碎片",
          _get: false,
          count: 0,
          total_number: 3
        }
      ],
        this.time = 0 // 清空探索次数
      // 迷宫部分
      // 🟢 初始化16个占位格子
      this.maze_list = Array.from({ length: 16 }, (_, i) => ({
        maze_id: i + 1,
        is_open: false,   // 初始都未打开
        // 这里可以加上任何你cg格子本来该有的字段
      }));

      this.eggCount = 0
      this.now_walk_number = 0 // 这个是用户当前在的位置
      this.can_walk_number = [] // 这个是当前可以点亮的格子
      this.currentSmokeId = null // 当前播放烟雾的方块 ID

      this.isBook = false//  是否预约
      // this.isRewardStart = false // 是否可以领取预约奖励
      const rewardStartTime = new Date("2025-12-25 11:00:00").getTime();
      const now = Date.now();
      this.isRewardStart = now >= rewardStartTime
      this.isBookSend = false // 是否领取预约奖励
      this.nowClickFk = ''
      this.eggShakeState = {
        1: true,
        2: true,
        3: true
      }
      this.eggVisible = true
      this.activity_start = false
      this.initializeDebounceMethods();
      this.resetKeys.forEach(key => {
        this[key] = false
      })
    },
    clearActiveInfo() {
      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    goLink(url) {
      if (url === '') return
      Indicator.open();
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },

    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo;
      selectInfo.account = this.userInfo.account;
      this.setUserInfo(selectInfo);
    },

    // 区组弹窗注销-相关参数复位
    osCancell() {
      this.user_info = {}
      this.changeOsPopup(false);
    },
    // TAG: 其他简易封装的方法
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    showEggToast(msg) {
      if (this.toastLock) return;

      this.toastLock = true;

      Toast({
        message: msg,
        duration: 1000
      });

      setTimeout(() => {
        this.toastLock = false;
      }, 1000);
    },
    // 打开遮罩
    onPreventShow() {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose() {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup(name) {
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;

      // 如果当前关闭的是普通奖励弹窗（1~5）并且探索完成，则显示最终弹窗
      if (this.isFinalReward && name.includes('RewardShow') && name !== 'sixRewardShow') {
        this.isFinalReward = false; // 避免重复触发
        this.$nextTick(() => {
          this.showFinalReward(); // 弹出最终奖励
        });
      }
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/maze/index/index.vue